import React from "react";
import {Row, Col, Skeleton} from "antd";
import {Link} from "react-router-dom";
import {Team} from "interfaces";
import useFetch from "hooks/fetch";

const Card : React.FC = () => {

    const [isLoading, datasource] = useFetch("team", "asc");

    return (
        <section className={"main-list"}>
            <div className={"public-container"}>
                <Row gutter={[50, 20]}>
                    {
                        (isLoading ? new Array(13).fill({}, 0, 13) : datasource)
                            .map((item : Team, x) => (
                           <Col key={x} lg={8} md={8} sm={24} xs={24}>
                               <Link to={`/team/${item.nickname}`}>
                                   <div className={"card-list"}>
                                       {
                                           isLoading
                                               ? <Skeleton.Avatar size={500} shape={"square"} active={true} />
                                               : <img src={item?.image?.url} alt={item.name} />
                                       }
                                   </div>
                                   <div className={"card-list-text"}>
                                       <h4>{item.name}</h4>
                                       <p>{item.position}</p>
                                   </div>
                               </Link>
                           </Col>
                        ))
                    }
                </Row>
            </div>
        </section>
    )
}

export default React.memo(Card);